module.exports = __webpack_public_path__ + "media/images/promoter/sabrina-small-square-5334dc9a15c0cd262e8f5729f6bcb91c.jpg";